import {HttpClient, HttpClientModule} from "@angular/common/http";
import {NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule, Routes} from "@angular/router";
import {AppComponent} from "./app.component";
import {CommonModule} from "./common/common.module";
import {MainPagesModule} from "./modules/MainPages.module";
import {ProfileModule} from "./modules/profile/profile.module";
import {KerkimSherbimeModule} from "./modules/sherbimet/sherbime.module";
import {TrackingModule} from "./modules/tracking/tracking.module";
import {HELIUS_POSTA_PROVIDERS} from "./services/providers";
import {PrintLayoutComponent} from "./common/components/print-layout/print-layout.component";
import {PrintChildHistoryComponent} from "./common/components/print-layout/print-child-history/print-child-history.component";
import { environment } from "src/environments/environment";

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

const routes: Routes = [{
    path: "print",
    outlet: "print",
    component: PrintLayoutComponent,
    children: [
        {path: "history/:criteria", component: PrintChildHistoryComponent}
    ]
}];

const staticImports = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: translateFactory,
      deps: [HttpClient]
    }
  }),
  BrowserModule,
  FormsModule,
  RouterModule.forRoot(routes),
  HttpClientModule,
  ReactiveFormsModule,
  CommonModule,
  MainPagesModule,
  ProfileModule,
  TrackingModule,
  KerkimSherbimeModule
]

let imports = staticImports
// if (environment.showTracking) {
//   imports = imports.concat(TrackingModule)
// }

// if (environment.showService) {
//   imports = imports.concat(KerkimSherbimeModule)
// }

@NgModule({
    imports: imports,
    providers: [HELIUS_POSTA_PROVIDERS],
    declarations: [AppComponent, PrintLayoutComponent, PrintChildHistoryComponent],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function translateFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
